const IconYoutube = () => {
  return (
    <path
      d="M23.498 6.186a2.972 2.972 0 0 0-2.096-2.097C19.425 3.5 12 3.5 12 3.5s-7.425 0-9.402.589a2.972 2.972 0 0 0-2.096 2.097C0 8.168 0 12 0 12s0 3.832.502 5.814a2.972 2.972 0 0 0 2.096 2.097c1.977.589 9.402.589 9.402.589s7.425 0 9.402-.589a2.972 2.972 0 0 0 2.096-2.097C24 15.832 24 12 24 12s0-3.832-.502-5.814zM9.545 15.568V8.432l6.545 3.568-6.545 3.568z"
      fill="currentColor"
      data-icon="icon-youtube"
    />
  );
};

export default IconYoutube;
